import { Component } from '@angular/core';
import {
  ChargeInformationDto,
  ChargeInformationService,
  DashboardService
} from '@app/api/dmc';
import { TableConfig } from '@shared/interfaces/table/table-config';
import { HeaderService } from '@app/core/services/header.service';
import { TableComponent } from '@shared/components/table/table.component';
import { GitPullRequestArrow } from 'lucide-angular';
import { ModalService } from '@app/core/services/modal.service';
import {
  DashboardRequestPriceComponent
} from '@shared/modals/dashboard/query/dashboard-request-price/dashboard-request-price.component';
import {queryDashboardConfig} from '@views/dashboard/config/query.dashboard-config';

@Component({
  selector: 'app-dashboard-chargeinformation-overdue',
  imports: [
    TableComponent
  ],
  templateUrl: './dashboard-chargeinformation-overdue.component.html',
  styleUrl: './dashboard-chargeinformation-overdue.component.css'
})
export class DashboardChargeinformationOverdueComponent {
  public tableData: ChargeInformationDto[] = [];
  public tableConfig: TableConfig<ChargeInformationDto> =
    queryDashboardConfig['chargeinformationpending'].tableConfig as TableConfig<ChargeInformationDto>;

  public selectedElements: ChargeInformationDto[] = [];

  constructor(
    private readonly headerService: HeaderService,
    private readonly dashboardService: DashboardService,
    private readonly modalService: ModalService,
    private readonly chargeInformationService: ChargeInformationService,
  ) {
    this.headerService.setTitle('dashboard.query.overduechargeinformation.title');

    this.headerService.setActions([
      {
        id: 'requestprice',
        title: 'dashboard.query.overduechargeinformation.requestprice',
        icon: GitPullRequestArrow,
        callback: () => this.openRequestModal(),
        disabled: () => this.selectedElements.length !== 1,
      }
    ])

    this.fetchData();
  }

  public fetchData(): void {
    this.chargeInformationService.chargeInformationGetOverduePendingGet().subscribe(
      (result: any) => {
        this.tableData = result.results || [];
      }
    )
  }

  public openRequestModal(): void {
    if (this.selectedElements.length !== 1) return;

    this.modalService.show({
      title: 'dashboard.query.overduechargeinformation.requestprice',
      component: DashboardRequestPriceComponent,
      actions: [
        { type: 'primary', label: 'system.button.ok', method: 'submit' },
        { type: 'secondary', label: 'system.button.cancel', closeOnClick: true },
      ],
    }).subscribe(() => {
      this.fetchData()
    })
  }

}
